import {
  Autocomplete,
  createTheme,
  NativeSelect,
  NumberInput,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import { DateInput } from "@mantine/dates";

import styles from "./styles/theme.module.scss";

const theme = createTheme({
  components: {
    Select: Select.extend({
      classNames: {
        option: styles.selectOption,
        label: styles.inputLabel,
        input: styles.input,
      },
    }),
    Autocomplete: Autocomplete.extend({
      classNames: {
        option: styles.selectOption,
      },
    }),
    TextInput: TextInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
      },
    }),
    DateInput: DateInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        day: styles.dateInputDay,
      },
    }),
    NativeSelect: NativeSelect.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
      },
    }),
    Textarea: Textarea.extend({
      classNames: {
        input: styles.textarea,
        label: styles.inputLabel,
      },
    }),
    NumberInput: NumberInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        control: styles.numberInputControl,
      },
    }),
  },
});

export default theme;
